import CTASMutations from './cta.mutation';
import CTASStates from './cta.state';
import CTASsActions from './cta.action';
import CTASGetters from './cta.getters';

export default {
  mutations: CTASMutations,
  state: CTASStates,
  actions: CTASsActions,
  getters: CTASGetters
};
